(() => {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const SHOP_EDIT_LINKS = {
    'New Arrivals': '/collections/all?sort_by=created-descending',
    'Best Seller': '/collections/all?sort_by=best-selling',
    'Trending': '/collections/premium-soft-silk-saree'
  };

  function installShopEditStyles() {
    if (document.getElementById('ks-shop-edit-v18-styles')) return;
    const style = document.createElement('style');
    style.id = 'ks-shop-edit-v18-styles';
    style.textContent = `
      body.index-template #MainContent [id^="ks-edit-"].ks-edit .ks-edit__inner {
        width: min(1120px, calc(100% - 64px)) !important;
      }
      body.index-template #MainContent [id^="ks-edit-"].ks-edit .ks-edit__track {
        display: grid !important;
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
        gap: clamp(16px, 1.6vw, 24px) !important;
        overflow: visible !important;
        padding: 0 !important;
        scroll-snap-type: none !important;
      }
      body.index-template #MainContent [id^="ks-edit-"].ks-edit .ks-edit__card {
        width: auto !important;
        min-width: 0 !important;
        flex: none !important;
        scroll-snap-align: none !important;
      }
      body.index-template #MainContent [id^="ks-edit-"].ks-edit .ks-edit__carousel-tools {
        display: none !important;
      }
      @media screen and (max-width: 989px) and (min-width: 750px) {
        body.index-template #MainContent [id^="ks-edit-"].ks-edit .ks-edit__inner {
          width: min(860px, calc(100% - 40px)) !important;
        }
        body.index-template #MainContent [id^="ks-edit-"].ks-edit .ks-edit__track {
          grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
          gap: 14px !important;
        }
      }
      @media screen and (max-width: 749px) {
        body.index-template #MainContent [id^="ks-edit-"].ks-edit .ks-edit__inner {
          width: 100% !important;
        }
        body.index-template #MainContent [id^="ks-edit-"].ks-edit .ks-edit__track {
          display: flex !important;
          gap: 12px !important;
          overflow-x: auto !important;
          overflow-y: visible !important;
          padding: 2px 18px 12px !important;
          scroll-padding-left: 18px !important;
          scroll-snap-type: x mandatory !important;
          scrollbar-width: none !important;
          overscroll-behavior-inline: contain !important;
          -webkit-overflow-scrolling: touch;
        }
        body.index-template #MainContent [id^="ks-edit-"].ks-edit .ks-edit__track::-webkit-scrollbar {
          display: none !important;
        }
        body.index-template #MainContent [id^="ks-edit-"].ks-edit .ks-edit__card {
          flex: 0 0 82% !important;
          scroll-snap-align: start !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function shopEditCardTitle(card) {
    return card.querySelector('.ks-edit__footer h3')?.textContent?.trim() || '';
  }

  function normalizeShopEdit(root) {
    if (!root) return;
    const track = root.querySelector('.ks-edit__track');
    if (!track) return;

    root.dataset.ksEditCarouselEnhanced = 'true';
    root.removeAttribute('data-ks-carousel');
    track.removeAttribute('data-ks-carousel-track');
    root.querySelectorAll('.ks-edit__carousel-tools').forEach((tools) => tools.remove());

    Array.from(track.querySelectorAll('.ks-edit__card')).forEach((card) => {
      if (shopEditCardTitle(card) === 'Shop by Occasion') card.remove();
    });

    const cards = Array.from(track.querySelectorAll('.ks-edit__card'));
    const newArrivals = cards.find((card) => shopEditCardTitle(card) === 'New Arrivals');
    if (newArrivals && track.firstElementChild !== newArrivals) track.prepend(newArrivals);

    track.querySelectorAll('.ks-edit__card').forEach((card) => {
      const href = SHOP_EDIT_LINKS[shopEditCardTitle(card)];
      if (href && card.getAttribute('href') !== href) card.setAttribute('href', href);
    });

    if (root.dataset.ksShopEditV18Observed !== 'true') {
      root.dataset.ksShopEditV18Observed = 'true';
      const observer = new MutationObserver(() => normalizeShopEdit(root));
      observer.observe(root, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['href', 'data-ks-carousel', 'data-ks-carousel-track']
      });
    }
  }

  function normalizeAllShopEdits() {
    installShopEditStyles();
    document.querySelectorAll('[id^="ks-edit-"].ks-edit').forEach(normalizeShopEdit);
  }

  function cardStep(track) {
    const card = track.firstElementChild;
    if (!card) return 0;
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function setProgress(root, track) {
    const fill = root.querySelector('[data-ks-progress-fill]');
    if (!fill) return;

    const max = Math.max(0, track.scrollWidth - track.clientWidth);
    if (max <= 2) {
      fill.style.width = '100%';
      return;
    }

    const visibleRatio = Math.min(1, track.clientWidth / track.scrollWidth);
    const travelRatio = Math.max(0, Math.min(1, track.scrollLeft / max));
    const start = visibleRatio * 100;
    const width = Math.min(100, start + travelRatio * (100 - start));
    fill.style.width = `${Math.max(start, width)}%`;
  }

  function initCarousel(root) {
    if (!root || root.dataset.ksCarouselReady === 'true') return;

    const track = root.querySelector('[data-ks-carousel-track]');
    if (!track) return;

    root.dataset.ksCarouselReady = 'true';

    const prev = root.querySelector('[data-ks-prev]');
    const next = root.querySelector('[data-ks-next]');
    const shouldAutoplay = root.dataset.ksAutoplay === 'true' && !reducedMotion.matches;

    let interval = null;
    let resumeTimer = null;

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function move(direction) {
      const step = cardStep(track);
      const max = maxScroll();
      if (!step || max <= 2) return;

      if (direction > 0 && track.scrollLeft >= max - 8) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (direction < 0 && track.scrollLeft <= 8) {
        track.scrollTo({ left: max, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: direction * step, behavior: 'smooth' });
      }
    }

    function stop() {
      window.clearInterval(interval);
      window.clearTimeout(resumeTimer);
      interval = null;
    }

    function start() {
      stop();
      if (!shouldAutoplay || maxScroll() <= 2 || document.hidden) return;
      interval = window.setInterval(() => move(1), 4600);
    }

    function resumeSoon() {
      stop();
      if (!shouldAutoplay) return;
      resumeTimer = window.setTimeout(start, 2400);
    }

    prev?.addEventListener('click', () => {
      move(-1);
      resumeSoon();
    });

    next?.addEventListener('click', () => {
      move(1);
      resumeSoon();
    });

    track.addEventListener('scroll', () => setProgress(root, track), { passive: true });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    track.addEventListener('touchstart', stop, { passive: true });
    track.addEventListener('touchend', resumeSoon, { passive: true });

    const resizeObserver = new ResizeObserver(() => {
      setProgress(root, track);
      start();
    });
    resizeObserver.observe(track);

    setProgress(root, track);
    start();
  }

  function enhanceShopEdit() {
    normalizeAllShopEdits();
  }

  function initAll() {
    if (!document.body.classList.contains('index-template')) return;
    enhanceShopEdit();
    document.querySelectorAll('[data-ks-carousel]').forEach(initCarousel);
    window.setTimeout(normalizeAllShopEdits, 300);
    window.setTimeout(normalizeAllShopEdits, 1200);
  }

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) initAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', () => {
    window.setTimeout(initAll, 0);
  });
})();
